import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, Row, Col, message, DatePicker, Radio, Typography, Spin } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import { SUBMISSION_FAILED, COMMON_ERROR_MSG } from "../../constants/constants";
import { routes } from "../../routes/Routes";
import IntegerInput from "../../components/IntergerInput";
import MaskedDigitsInput from "../../components/MaskedDigitsInput";
import PhoneInput from "react-phone-input-auto-format";
import moment from "moment";
import ShowApplicationId from "../NewApplication/ShowApplicationId";
import ApplicationProgressBar from "./ApplicationProgressBar";
import { LeftOutlined, RightOutlined, ArrowRightOutlined } from '@ant-design/icons';
import ButtonComponent from "../../components/Button/Button";

const { Option } = Select;
const { Title } = Typography;


const IdentificationOfCoBorrower = () => {

    const [loading, setLoading] = useState(false);
    // const [uploading, setUploading] = useState(false);
    const history = useHistory();
    const [form] = Form.useForm();
    // const [fileList, setFileList] = useState([]);
    // const [imagePath, setImagePath] = useState(undefined);
    // const [imagePathValue, setImagePathValue] = useState(undefined);
    // const [file, setFile] = useState({});
    const [idtypes, setidtypes] = useState([]);
    const [applicantInfo, setApplicantInfo] = useState({});
    const [isFieldsDisabled, SetIsFieldsDisabled] = useState(false);
    // const [imageUrl, setimageUrl] = useState(undefined);
    let APPLICATION_TYPE_ID = localStorage.getItem("applicationTypeId");
    const applicationId = localStorage.getItem("ApplicationId");

    const location = useLocation();
    let data = location.state;
    let applnObjId = "";
    let activeKeyTab = null;
    let fromDashboard = false;

    if (data && data.applicationObjId) {
        applnObjId = data.applicationObjId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }

    if (data && data.activeKey) {
        activeKeyTab = data.activeKey;
    }

    const [appObjId] = useState(applnObjId);
    const [isFromDashboard] = useState(fromDashboard);
    const [tabActiveKey] = useState(activeKeyTab);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        getidtypes();
        // uploadImageToServer();
        getApplicantDetailsByID();
    }, []);

    useEffect(() => form.resetFields(), [applicantInfo]);

    // Upload image to server
    // const uploadImageToServer = async (file) => {
    //     const formData = new FormData();
    //     formData.append("files[]", file);
    //     // formData.append("ScreenName", "applicantphotoimage");
    //     // formData.append("ApplicationId", localStorage.getItem("Id"));
    //     let ApplicationId = localStorage.getItem("Id");
    //     setUploading(true);
    //     try {
    //         const res = await _NewapplicationService.UploadPhotoImage(formData, ApplicationId, "coborrowerphotoimage");

    //         // const applicationId = localStorage.getItem("ApplicationId");
    //         // const res = await fetch(
    //         //   `http://98.70.41.158:9090/api/UploadImages/UploadPhotoImage?uploadPhotoName=coborrowerphotoimage&applicationId=8`,
    //         //   {
    //         //     method: "POST",
    //         //     body: formData,
    //         //   }
    //         // );

    //         // debugger
    //         if (res?.data?.IsSucess && res?.data?.Message) {
    //             setUploading(false);
    //             let relativePath = new URL(res.data.URL).pathname;
    //             setImagePath(relativePath);
    //             setimageUrl(res.data.URL);

    //             notification.success({
    //                 description: res?.data?.Message,
    //                 icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
    //                 duration: 3,
    //                 placement: "top"
    //             });
    //         } else {
    //             setUploading(false);
    //             notification.error({
    //                 message: "Upload Failed",
    //                 description: res?.data?.Message || `${file.name} failed to upload.`,
    //                 icon: <CloseCircleOutlined style={{ color: "#ff4d4f" }} />,
    //                 duration: 3,
    //                 placement: "top"
    //             });
    //         }


    //     } catch (err) {
    //         console.error("Upload error:", err);
    //         setUploading(false);
    //         // message.error(err.message || "Server error during image upload");
    //         return null;
    //     }
    // };

    // const preventRequest = async (file) => {
    //     const isValidType = file?.type?.toLowerCase().includes("image");
    //     const isLt10MB = file?.size <= 10 * 1024 * 1024;

    //     if (!isValidType) {
    //         message.error("Only JPG/PNG files allowed!");
    //         return Upload.LIST_IGNORE;
    //     }

    //     if (!isLt10MB) {
    //         message.error("Image must be under 10MB!");
    //         return Upload.LIST_IGNORE;
    //     }

    //     const uploadedPath = await uploadImageToServer(file);

    //     if (uploadedPath) {
    //         setImagePath(uploadedPath); // backend path
    //         setImagePathValue(URL.createObjectURL(file)); // preview
    //         setFile(file);
    //     }

    //     return false; // prevent antd default upload
    // };

    // const preventRequest = async (file) => {
    //     // const isValidType = file?.type === "image/png" || file?.type === "image/jpeg";
    //     // const isGt155KB = file?.size >= 155 * 1024; // 158720 bytes
    //     // const isLt350KB = file?.size <= 350 * 1024; // 358400 bytes

    //     // if (!isValidType) {
    //     //     message.error("Only JPG/PNG files allowed!");
    //     //     setFile(undefined);
    //     //     setImagePathValue(undefined);
    //     //     return Upload.LIST_IGNORE;
    //     // }

    //     // if (!isGt155KB || !isLt350KB) {
    //     //     message.error("Image size must be between 155KB and 350KB!");
    //     //     setFile(undefined);
    //     //     setImagePathValue(undefined);
    //     //     return Upload.LIST_IGNORE;
    //     // }

    //     // const uploadedPath = await uploadImageToServer(file);

    //     // if (uploadedPath) {
    //     //     setImagePath(uploadedPath); // backend path
    //     //     setImagePathValue("test"); // preview
    //     //     setFile(file);
    //     // }

    //     // return false; // prevent antd default upload

    //     if (
    //         file &&
    //         file.type &&
    //         file.type.toLowerCase().includes("image") &&
    //         file.size <= 10000000 && file?.size >= 155 * 1024 && file?.size <= 350 * 1024
    //     ) {
    //         const uploadedPath = await uploadImageToServer(file);

    //         if (uploadedPath) {
    //             setImagePath(uploadedPath);
    //             setFile(file);
    //             setImagePathValue("test");
    //         }
    //         return false;
    //     } else {
    //         setFile(undefined);
    //         setImagePathValue(undefined);
    //         const isValidType = file?.type === "image/png" || file?.type === "image/jpeg";
    //         const isGt155KB = file?.size >= 155 * 1024; // 158720 bytes
    //         const isLt350KB = file?.size <= 350 * 1024; // 358400 bytes

    //         if (!isValidType) {
    //             message.error("Only JPG/PNG files allowed!");
    //             return Upload.LIST_IGNORE;
    //         }

    //         if (!isGt155KB || !isLt350KB) {
    //             message.error("Image size must be between 155KB and 350KB!");
    //             return Upload.LIST_IGNORE;
    //         }
    //     }
    // };

    // const removeFile = () => {
    //     setFile({});
    //     setImagePath(undefined);
    //     setImagePathValue(undefined);
    // };

    // const onDeleteImage = () => {
    //     confirm({
    //         title: "Are you sure, want to delete this Photo Of ID?",
    //         icon: <ExclamationCircleOutlined />,
    //         okText: <span id="yesBtn">Yes</span>,
    //         cancelText: <span id="noBtn">No</span>,
    //         okType: "primary",
    //         onOk() {
    //             onCancelImage();
    //         }
    //     });
    // };

    // const onCancelImage = async () => {
    //     setFile(undefined);
    //     form.setFieldsValue({ PhotoOfID: "" });
    //     setImagePath(undefined);
    //     setImagePathValue(undefined);
    //     setApplicantInfo({ ...applicantInfo, PhotoOfID: null })
    // };

    const onFinish = async (values) => {
        const dateOfIssue = values.dateOfIssue?.format("YYYY-MM-DD");
        const expirationDate = values.expirationDate?.format("YYYY-MM-DD");
        setLoading(true);
        let reqObj = {
            Id: localStorage.getItem("Id"),
            ScreenName: "coborroweridentification",
            ApplicationId: localStorage.getItem("ApplicationId"),
            CoB_Ident_Type_Id: values.IDType,
            CoB_Ident_Identification_Number: values.identificationNumber,
            CoB_Ident_DateOfIssue: dateOfIssue,
            CoB_Ident_ExpirationDate: expirationDate,
            CoB_Ident_Address_Type: values && values.coborrowersaddress == 'sameAsApplicant' ? true : false,
            // CoB_Ident_State_Of_Issue_Id: 8,
            CoB_Ident_Nationality: values.nationality,
            // CoB_Ident_Address_Type: 1,
            CoB_Ident_Physical_Address: values.physicalAddress,
            CoB_Ident_City: values.city,
            CoB_Ident_State: values.state,
            CoB_Ident_ZipCode: values.zipcode,
            CoB_Ident_SSN_Number: values.ssnumber,
            CoB_Ident_Years_Of_Residence: values.YearsOfResidence,
            // CoB_Ident_Photo_Of_Id_Path: imagePath,
            CoB_Ident_State_Of_Issue: values.stateOfIssue,
            CoB_Sp_EmployerName: values.employerName,
            CoB_Sp_BusinessPhone: values.employerBusinessPhone,
            CoB_Sp_StreetAddress: values.employerStreetAddress,
            CoB_Sp_City: values.employerCity,
            CoB_Sp_State: values.employerState,
            CoB_Sp_ZipCode: values.employerZip,
            CoB_Sp_NoOfYears: values.employerNoofYears,
            CoB_Sp_PositionTitle: values.employerPositionTitle,
            CoB_Sp_NoOfDependant: values.employerNoofDependents,
            CoB_Sp_AgeOfDependant: values.employerAgeOfDependents,
            IsCoborrowerIdentificationCompleted: true,
        }
        try {
            const res = await _NewapplicationService.submitApplicantData(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                if (isFromDashboard) {
                    history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
                } else {
                    history.push(routes.uploaddocuments.path);
                }
            } else {
                setLoading(false);
                message.error(res.data.message ? res.data.message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
        }
        finally {
            setLoading(false);
        }

    };
    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        } else {
            if (APPLICATION_TYPE_ID == "4") {
                history.push(routes.coBorrowersDetails.path);
            }
        }
    }

    const getidtypes = async () => {
        try {
            const res = await _NewapplicationService.getAllDropdownDataByName("idtypes");
            if (res.data) {
                setidtypes(res.data);
            }
        } catch (e) {
            console.log(e);

        }
    };

    let Id = localStorage.getItem("Id");

    const getApplicantDetailsByID = async () => {
        try {
            setLoading(true);
            const res = await _NewapplicationService.getApplicantInformationByApplicationId(isFromDashboard ? appObjId : Id);
            console.log("ab res", res)
            if (res.data) {
                let resObj = res?.data;

                if (resObj.CoB_Ident_Address_Type == true) {
                    SetIsFieldsDisabled(true);
                } else {
                    SetIsFieldsDisabled(false);
                }

                setApplicantInfo({
                    ...resObj,
                    IDType: resObj.CoB_Ident_Type_Id,
                    identificationNumber: resObj.CoB_Ident_Identification_Number,
                    dateOfIssue: resObj.CoB_Ident_DateOfIssue ? moment(resObj.CoB_Ident_DateOfIssue) : null,
                    expirationDate: resObj.CoB_Ident_ExpirationDate ? moment(resObj.CoB_Ident_ExpirationDate) : null,
                    stateOfIssue: resObj.CoB_Ident_State_Of_Issue,
                    nationality: resObj.CoB_Ident_Nationality,
                    coborrowersaddress: resObj.CoB_Ident_Address_Type == true ? "sameAsApplicant" : "enterManually",
                    physicalAddress: resObj.CoB_Ident_Address_Type == true ? resObj.Ident_Physical_Address : resObj.CoB_Ident_Physical_Address,
                    city: resObj.CoB_Ident_Address_Type == true ? resObj.Ident_City : resObj.CoB_Ident_City,
                    state: resObj.CoB_Ident_Address_Type == true ? resObj.Ident_State : resObj.CoB_Ident_State,
                    zipcode: resObj.CoB_Ident_Address_Type == true ? resObj.Ident_ZipCode : resObj.CoB_Ident_ZipCode,
                    ssnumber: resObj.CoB_Ident_SSN_Number,
                    // physicalAddress: resObj.CoB_Ident_Physical_Address,
                    // city:  resObj.CoB_Ident_City,
                    // state: resObj.CoB_Ident_State,
                    // zipcode: resObj.CoB_Ident_ZipCode,
                    YearsOfResidence: resObj.CoB_Ident_Years_Of_Residence,
                    employerName: resObj.CoB_Sp_EmployerName,
                    employerBusinessPhone: resObj.CoB_Sp_BusinessPhone || "",
                    employerStreetAddress: resObj.CoB_Sp_StreetAddress,
                    employerCity: resObj.CoB_Sp_City,
                    employerZip: resObj.CoB_Sp_ZipCode,
                    employerState: resObj.CoB_Sp_State,
                    employerNoofYears: resObj.CoB_Sp_NoOfYears,
                    employerPositionTitle: resObj.CoB_Sp_PositionTitle,
                    employerNoofDependents: resObj.CoB_Sp_NoOfDependant,
                    employerAgeOfDependents: resObj.CoB_Sp_AgeOfDependant,
                    // PhotoOfID: resObj.CoB_Ident_Photo_Of_Id_Path,
                });
                // setImagePath(resObj.CoB_Ident_Photo_Of_Id_Path);
                // setImagePathValue(resObj.CoB_Ident_Photo_Of_Id_Path);
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };

    const onValuesChange = (changedValues) => {
        const fieldName = Object.keys(changedValues)[0];
        if (fieldName === "coborrowersaddress" && changedValues.coborrowersaddress) {
            if (changedValues.coborrowersaddress == 'sameAsApplicant') {
                SetIsFieldsDisabled(true);
                form.setFieldsValue({
                    physicalAddress: applicantInfo && applicantInfo.Ident_Physical_Address,
                    city: applicantInfo && applicantInfo.Ident_City,
                    state: applicantInfo && applicantInfo.Ident_State,
                    zipcode: applicantInfo && applicantInfo.Ident_ZipCode,
                });
            } else {
                SetIsFieldsDisabled(false);
                form.setFieldsValue({
                    physicalAddress: "",
                    city: "",
                    state: "",
                    zipcode: "",
                });
            }
        }
    };

    return (
        <Spin spinning={loading}>
            <LeftLayout>
                {/* {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                <div style={{
                    position: "absolute",
                    top: 5,
                    right: 20,
                    margin: 0,
                    zIndex: 1000,
                    maxWidth: "1000px",
                    padding: "8px 16px",
                }}>
                    <ApplicationProgressBar />
                    <Title level={3} style={{ margin: 0 }}>
                        <ShowApplicationId />
                    </Title>
                </div>
            )} */}
                <div>
                    {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                        <div>
                            <ApplicationProgressBar />
                            <Title level={5}>
                                {/* <ShowApplicationId /> */}
                            </Title>
                        </div>
                    )}
                </div>

                <div className="application-dark-page">
                    <div className="application-card">
                        <Row>
                            <Col span={24}>
                                <Title className="mt50" level={3} style={{ marginBottom: 25 }}> Identification Of The Co-Borrower </Title>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onFinish}
                                    initialValues={applicantInfo}
                                    onValuesChange={onValuesChange}
                                >
                                    {/* <Form.Item
                                        label="ID Type"
                                        name="IDType"
                                        className='w50'
                                        rules={[{ required: true, message: 'ID Type is required' }]}
                                    >
                                        <Select placeholder="Select ID Type">
                                            {idtypes.map((type) => (
                                                <Option key={type.Name} value={type.Id}>
                                                    {type.Name}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item> */}



                                    {/* <Form.Item
                                        label="ID Number"
                                        name="identificationNumber"
                                        className='w50'
                                        rules={[{ required: true, message: "ID Number is required" }]}
                                    >
                                        <MaskedDigitsInput placeholder="Enter ID Number" maxLength={30}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const sanitized = value.replace(/[^a-zA-Z0-9]/g, ''); // Only letters and numbers
                                                form.setFieldsValue({ identificationNumber: sanitized });
                                            }} />
                                    </Form.Item> */}

                                    {/* <Form.Item
                                        label="Date Of Issue"
                                        name="dateOfIssue"
                                        className="w50"
                                        rules={[{ required: true, message: "Date Of Issue is required" }]}
                                    >
                                        <DatePicker
                                            placeholder="Select Date Of Issue"
                                            style={{ width: "100%" }}
                                            format="MM/DD/YYYY"
                                            disabledDate={(current) =>
                                                current && current > moment().endOf("day") // No future dates allowed
                                            }
                                        />
                                    </Form.Item> */}

                                    {/* <Form.Item
                                        label="Expiration Date"
                                        name="expirationDate"
                                        className="w50"
                                        dependencies={["dateOfIssue"]}
                                        rules={[
                                            { required: true, message: "Expiration Date is required" },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    const dateOfIssue = getFieldValue("dateOfIssue");
                                                    if (!value || !dateOfIssue) {
                                                        return Promise.resolve();
                                                    }
                                                    if (value.isSameOrAfter(dateOfIssue, "day")) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        new Error("Expiration Date must be the same as or after Date Of Issue")
                                                    );
                                                },
                                            }),
                                        ]}
                                    >
                                        <DatePicker
                                            placeholder="Select Expiration Date"
                                            style={{ width: "100%" }}
                                            format="MM/DD/YYYY"
                                            disabledDate={(current) => {
                                                if (!current) return false;
                                                const dateOfIssue = form.getFieldValue("dateOfIssue");
                                                const today = moment().startOf("day");
                                                let minDate = today;
                                                if (dateOfIssue) {
                                                    const issueDay = moment(dateOfIssue).startOf("day");
                                                    minDate = moment.max(issueDay, today);
                                                }
                                                return current.startOf("day").isBefore(minDate);
                                            }}
                                        />
                                    </Form.Item> */}


                                    {/* <Form.Item
                                        label="State Of Issue"
                                        name="stateOfIssue"
                                        className='w50'

                                        rules={[{ required: true, message: "State Of Issue is required" }]}
                                    >
                                        <Input placeholder="Enter State Of Issue" maxLength={30} />
                                    </Form.Item> */}


                                    {/* <Form.Item
                                        label="Nationality"
                                        name="nationality"
                                        className='w50'
                                        rules={[{ required: true, message: "Nationality is required" }]}

                                    >
                                        <Input placeholder="Enter Nationality" maxLength={30} />
                                    </Form.Item> */}

                                    <Form.Item
                                        label="Years Of Residence"
                                        name="YearsOfResidence"
                                        className='w50'
                                    >
                                        <IntegerInput placeholder="Enter Years Of Residence" maxLength={30} />
                                    </Form.Item>

                                    <Form.Item
                                        label="Co-Borrowers Address"
                                        name="coborrowersaddress"
                                        className='w50'
                                        rules={[{ required: true, message: "Co-Borrowers Address is required" }]}
                                    >
                                        <Radio.Group>
                                            <Radio value="sameAsApplicant" style={{ display: 'block' }}>Same as Client</Radio>
                                            <Radio value="enterManually" style={{ display: 'block' }}>Enter address manually</Radio>
                                        </Radio.Group>
                                    </Form.Item>

                                    <Form.Item
                                        label="Street Address"
                                        name="physicalAddress"
                                        className='w50'
                                        rules={[{ required: true, message: "Street Address is required" }]}
                                    >
                                        <Input.TextArea placeholder="Enter Street Address" maxLength={500} disabled={isFieldsDisabled ? true : false} autoSize={{ minRows: 1, maxRows: 5 }} />
                                    </Form.Item>

                                    <Form.Item
                                        label="City"
                                        name="city"
                                        className='w50'
                                        rules={[{ required: true, message: "City is required" }]}
                                    >
                                        <Input placeholder="Enter City" maxLength={30} disabled={isFieldsDisabled ? true : false} />
                                    </Form.Item>

                                    <Form.Item
                                        label="State"
                                        name="state"
                                        className='w50'
                                        rules={[{ required: true, message: "State is required" }]}
                                    >
                                        <Input placeholder="Enter State" maxLength={30} disabled={isFieldsDisabled ? true : false} />
                                    </Form.Item>

                                    {/* <Form.Item
                                        label="Zip Code"
                                        name="zipcode"
                                        className='w50'
                                        rules={[{ required: true, message: "Zip Code is required" }]}
                                    >
                                        <IntegerInput placeholder="Enter Zip Code" maxLength={6} disabled={isFieldsDisabled ? true : false} />
                                    </Form.Item> */}

                                    <Form.Item
                                        label="Zip Code"
                                        name="zipcode"
                                        className='w50'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Zip Code is required',
                                            },
                                            {
                                                pattern: /^\d{5}(-\d{4})?$/,
                                                message: 'Enter a valid ZIP Code (e.g., 12345 or 12345-6789)',
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="Enter Zip Code"
                                            maxLength={10} // Supports 12345-6789
                                        />
                                    </Form.Item>

                                    {/* <Form.Item
                                        label="SSN / ITIN"
                                        name="ssnumber"
                                        className='w50'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'SSN Number is required',
                                            },
                                        ]}
                                    >
                                        <MaskedDigitsInput
                                            placeholder="Enter SSN Number"
                                            maxLength={10}
                                        />
                                    </Form.Item> */}


                                    <Form.Item
                                        label="Employer Name"
                                        name="employerName"
                                        className='w50'
                                    >
                                        <Input placeholder="Enter Employer Name" maxLength={30} />
                                    </Form.Item>

                                    <Form.Item
                                        label="Employer Business Phone"
                                        name="employerBusinessPhone"
                                        className="w50"
                                        rules={[
                                            { required: false, message: "Employer Business Phone is required" },
                                            {
                                                validator: (_, value) => {
                                                    if (!value) {
                                                        return Promise.resolve(); //  Allow empty value if not required
                                                    }
                                                    const digits = value.replace(/\D/g, '');
                                                    if (digits.length === 10) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        new Error("Wrong format! please use this format (XXX) XXX-XXXX")
                                                    );
                                                },
                                            }
                                        ]}
                                    >
                                        <PhoneInput
                                            placeholder="Enter Employer Business Phone"
                                            inputComponent={Input}
                                            autoComplete="off"
                                            onChange={(value) => {
                                                // Remove non-digit characters and store the raw number
                                                const digits = value.replace(/\D/g, '');
                                                form.setFieldsValue({ employerBusinessPhone: digits });
                                            }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Employer Street Address"
                                        name="employerStreetAddress"
                                        className='w50'
                                    >
                                        <Input.TextArea placeholder="Enter Employer Street Address" maxLength={500} autoSize={{ minRows: 1, maxRows: 5 }} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Employer City"
                                        name="employerCity"
                                        className='w50'
                                    >
                                        <Input placeholder="Enter Employer City" maxLength={30} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Employer State"
                                        name="employerState"
                                        className='w50'
                                    >
                                        <Input placeholder="Enter Employer State" maxLength={30} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Employer Zip Code"
                                        name="employerZip"
                                        className='w50'
                                    >
                                        <IntegerInput placeholder="Enter Employer Zip Code" maxLength={30} />
                                    </Form.Item>
                                    <Form.Item
                                        label="No. Of Years"
                                        name="employerNoofYears"
                                        className='w50'
                                    >
                                        <IntegerInput placeholder="Enter No. Of Years" maxLength={3} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Position/Title"
                                        name="employerPositionTitle"
                                        className='w50'
                                    >
                                        <Input placeholder="Enter Position/Title" maxLength={30} />
                                    </Form.Item>
                                    <Form.Item
                                        label="No. Of Dependents"
                                        name="employerNoofDependents"
                                        className='w50'
                                    >
                                        <IntegerInput placeholder="Enter No. Of Dependents" maxLength={3} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Age Of Dependents"
                                        name="employerAgeOfDependents"
                                        className='w50'
                                    >
                                        <Input
                                            placeholder="Enter Age Of Dependents"
                                            maxLength={3}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and commas
                                                const filteredValue = value.replace(/[^0-9,]/g, '');

                                                // Update the input value directly
                                                e.target.value = filteredValue;

                                                // If you have form instance, update the form value here:
                                                form.setFieldsValue({ employerAgeOfDependents: filteredValue });
                                            }}
                                        />
                                    </Form.Item>


                                    {/* 
                        <Form.Item
                            label="Photo Of ID" 
                            name="PhotoOfID"
                             
                            rules={[
                                {
                                    required: true,
                                    validator() {
                                        if (imagePath && imagePath !== "") {
                                            return Promise.resolve();
                                        }
                                        //return Promise.reject(new Error("Photo Of ID is required"));

                                        return Promise.reject(
                                            new Error("Photo Of Id is required")
                                        );
                                    },
                                },
                            ]}
                        >
                            <Upload
                                name="image"
                                accept=".png,.jpeg,.jpg"
                                beforeUpload={preventRequest}
                                onRemove={removeFile}
                                listType="picture-card"
                                showUploadList={false}
                                maxCount={1}
                            >
                                {imagePathValue ? (
                                    <img
                                        src={imagePathValue}
                                        alt="Photo Of ID"
                                        style={{ width: "100%", maxWidth: "200px" }}
                                    />
                                ) : (
                                    <div>
                                        <UploadOutlined />
                                        <div>Click to Upload</div>
                                    </div>
                                )}
                            </Upload>
                            {fileFormatText}
                        </Form.Item> 
 */}

                                    {/* <Form.Item
                                label="Photo Of ID"
                                name="PhotoOfID"
                                rules={[
                                    {
                                        required: true,
                                        validator() {
                                            if ((imagePath && imagePath !== "") || (applicantInfo && applicantInfo.PhotoOfID)) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error("Photo Of ID is required"));
                                        },
                                    },
                                ]}
                            >
                                {imagePath && imagePath != "" ? (
                                    <div id="imgDiv" className="imgDiv mb10">
                                        <Tooltip title="Download Photo Of ID">
                                            <a
                                                href={APP_BLOB_ROOT + imagePath}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                download // triggers download behavior in supported browsers
                                            >
                                                <img
                                                    id="logoImage"
                                                    className="logoImg"
                                                    src={APP_BLOB_ROOT + imagePath}
                                                    alt="Uploaded ID"
                                                />
                                            </a>
                                        </Tooltip>

                                        <Tooltip title="Delete Photo Of ID">
                                            <Button
                                                id="deleteLogoBtn"
                                                type="text"
                                                icon={<DeleteOutlined />}
                                                danger
                                                onClick={onDeleteImage}
                                            />
                                        </Tooltip>

                                    </div>
                                ) : (
                                    <Upload
                                        accept="image/png,image/jpeg,image/gif,image/bmp"
                                        beforeUpload={preventRequest}
                                        onRemove={removeFile}
                                        listType="picture"
                                        maxCount={1}
                                    >
                                        <Button id="clickToUploadBtn" className="mb10" icon={<UploadOutlined />}>
                                            Click to Upload
                                        </Button>
                                    </Upload>
                                )}
                                <div>{fileFormatText}</div>
                            </Form.Item> */}


                                    <Form.Item >
                                        <div style={{ display: "flex", gap: 16, marginTop: 20 }} className="w95">
                                            <ButtonComponent
                                                type="default"
                                                onClick={onBack}
                                                icon={<LeftOutlined />}
                                                text="Go Back"
                                            />

                                            <ButtonComponent
                                                type="primary"
                                                htmlType="submit"
                                                disabled={![1, 2, 4, 9].includes(applicantInfo && applicantInfo.Application_Status_Id) ? true : false}
                                                text={
                                                    <span>
                                                        Save And Proceed <ArrowRightOutlined />
                                                    </span>
                                                }
                                                // text="Save And Proceed"
                                                icon={<RightOutlined />}
                                            />

                                        </div>
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                </div>
            </LeftLayout>
        </Spin>
    );
};

export default IdentificationOfCoBorrower;